export const CrossSmall = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.45703 6.45801L13.5404 13.5413M13.5404 6.45801L6.45703 13.5413"
      stroke={"currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default CrossSmall
